import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h2>Inventory is coming soon!</h2>
        </div>
    );
};

export default Inventory;